import React, { useEffect, useState } from 'react';
import Card from '@/components/common/Card';
import themeJson from './purple-passion.json';
import { Button } from '../../../../../components/ui/button';
import { DownloadIcon } from 'lucide-react';
import domtoimage from 'dom-to-image';
import EChartsReact from "echarts-for-react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useSelector } from 'react-redux';

const WholeCurveTimeSeriesChart = (props) => {
    const { chartData, isLoading, ycrAssetData, actualPrepareAssetValueData,selectDateType, setSelectDateType } = props;
    const { assetValueData } = useSelector((state) => state);
    const [option, setOption] = useState({});
    const [prePareData, setPrepareData] = useState(null);
    const [xAxis, setXAxis] = useState([]);
    // const [selectDateType, setSelectDateType] = useState(null);
    const [chartLoad, setChartLoad] = useState(false);
    // const [applyDateType, setApplyDateType] = useState(false);


    useEffect(() => {
        let result = null;
        result = actualPrepareAssetValueData?.length > 0 && sortRecordsByDate(actualPrepareAssetValueData);

        const { groupedRecordsByMonth } = recordsByMonthGroup(result,selectDateType);
        const { groupedRecordsByDate } = recordsByDateGroup(result);
        const xAxisMonths = sortDynamicMonths(Object.keys(groupedRecordsByMonth))
        let chartData = setAssetValuesByMonths(groupedRecordsByDate, xAxisMonths,selectDateType);
        const formattedChartData = transformChartData(chartData);
        setXAxis(xAxisMonths)
        setPrepareData(formattedChartData)

    }, [actualPrepareAssetValueData,selectDateType?.value]);


    const sortRecordsByDate = (records) => {
        return records?.sort((a, b) => {
            // Implement your sorting logic here
            // For example, sorting by date
            if (a?.date < b?.date) return -1;
            if (a?.date > b?.date) return 1;
            // If dates are equal, sort by asset index
            if (a?.asset?.month < b?.asset?.month) return -1;
            if (a?.asset?.month > b?.asset?.month) return 1;
            return 0;
        });
    };



    function setAssetValuesByMonths(groupedRecordsByDate, xAxisMonths,selectValue) {
        const time = selectValue?.value === "year" ? "year" : "month"
        for (let [key, value] of Object.entries(groupedRecordsByDate)) {
            let finalValues = []

            for (let x in xAxisMonths) {
                let month = parseFloat(xAxisMonths[x].split(" ")[0]);
                const record = value.find(x => x[time] === month)

                if (record) {
                    finalValues.push(record)
                } else {
                    finalValues.push(null)
                }

            }

            groupedRecordsByDate[key] = finalValues
        }

        return groupedRecordsByDate
    }

    const recordsByMonthGroup = (records,selectValue) => {

        const time = selectValue?.value === "year" ? "year" : "month"
        const timePrefix = selectValue?.value === "year" ? "Yr" : "Mo"

        const groupedRecords = records && records?.reduce((acc, item) => {
            const month = item?.asset[time] ? `${item?.asset[time]} ${timePrefix}` : "Other";
            if (!acc[month]) {
                acc[month] = [];
            }

            let formattedItem = {
                value: item.value,
                date: new Date(item.date).toLocaleDateString("en-GB"),
                tenor: `${item?.asset?.country?.alpha2Code}-${item?.asset?.maturity}-${item?.asset?.interestRateDataType?.type}`,
                country: item?.asset?.country?.alpha2Code,
            };

            acc[month].push(formattedItem);
            delete acc?.Other;
            return acc;
        }, {});


        const objectToArray = [];

        for (let [key, value] of Object.entries(groupedRecords)) {
            const obj = {};
            obj[key] = value;
            objectToArray.push(obj);
        }

        return { groupedRecordsByMonth: groupedRecords, arrayRecords: objectToArray };
    };
    const transformChartData = (chartData) => {
        let transformedData = [];
        for (let key in chartData) {
            if (chartData.hasOwnProperty(key)) {
                if (key !== 'Other') {
                    transformedData.push({
                        name: key,
                        label: key,
                        type: 'line',
                        data: chartData[key]
                    });

                }
            }
        }
        return transformedData;
    };


    const recordsByDateGroup = (records) => {
        const groupedRecords = records && records.reduce((acc, item) => {
            const dateString = new Date(item.date).toLocaleDateString("en-GB"); // Format the date
            if (!acc[dateString]) {
                acc[dateString] = [];
            }

            acc[dateString].push({
                value: item.value,
                date: dateString, // Use the formatted date string
                tenor: `${item?.asset?.country.alpha2Code}-${item?.asset?.maturity}-${item?.asset?.interestRateDataType?.type}`,
                country: item?.asset?.country?.alpha2Code,
                month: item?.asset?.month,
                year: item?.asset?.year || null,
            });
            return acc;
        }, {});


        return { groupedRecordsByDate: groupedRecords };
    };


    useEffect(() => {
        if (chartData?.length && assetValueData?.records?.length && assetValueData?.assets?.length) {
            // Extract records and assets from props
            //  let { records, assets } = assetValueData;

            //  // Update records with asset details
            //  records.forEach(item => {
            //      const asset = (item.asset && assets?.length) ? assets.find(asset => String(asset._id) === String(item.asset)) : undefined;
            //      item.asset = asset;
            //  });

            //  // Sort records by date and group by month
            //  records = sortRecordsByDate(records);
            //  const { groupedRecords } = recordsByMonthGroup(records);

            //  // Prepare data for ECharts
            //  const formattedChartData = transformChartData(groupedRecords);
            function sortDynamicMonths(arr) {
                return arr.sort((a, b) => {
                    // Extract the numeric part (assuming "Mo" is always at the end)
                    const numA = parseFloat(a.split(" ")[0]); // Split by space and take first part
                    const numB = parseFloat(b.split(" ")[0]);

                    // Sort numerically
                    return numA - numB;
                });
            }

            const option = {
                tooltip: {
                    trigger: 'item',
                    // axis: 'auto',
                    axisPointer: { type: 'shadow' },
                    // displayMode: 'single',
                    // renderMode: 'html',
                    // Confining tooltip to the body
                    confine: true,
                    align: 'center',
                    backgroundColor: '#001F3D',
                    appendToBody: false,
                    height: 10,
                    width: 50,
                    borderColor: "rgba(222, 16, 16, 1)",
                    extraCssText: "displays",
                    className: "chart_tooltip",
                    display: 'none',
                    textStyle: {
                        fontSize: 12, // Adjust the font size as needed
                        color: '#FFFFFF',
                    },
                    axisPointer: {
                        label: {
                            width: 50,
                            height: 10,
                            textBorderWidth: 5,
                            textBorderColor: "rgba(222, 16, 16, 1)"
                        }
                    },
                    formatter: function (params) {
                        // assetValueData
                        const slug = params.name; // Main date from the x-axis
                        const value = params?.data?.value ?? "-"; // Main value
                        const additionalDate = params?.data?.date; // Replace this with your actual additional date logic

                        return `<div style=" display: flex;justify-content: space-between;align-items: center;"><span>${slug}</span> <span>${additionalDate}</span></div> <div>${params.marker} ${params?.data?.tenor} : ${value}</div> <br/>`;
                    },
                },
                legend: {
                    // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
                    type: 'scroll',
                    right: 0,
                    top: 0,
                    left: 0,
                },
                grid: {
                    left: '7%',
                    right: '7%',
                    bottom: '10%',
                    containLabel: true
                },

                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xAxis,
                    axisPointer: {
                        label: {
                            show: true,
                        },
                        type: 'shadow',

                    },
                    axisLabel: {
                        margin: 10,
                        interval: 0,
                        rotate: 60,
                    },
                },
                yAxis: {
                    type: 'value',
                    position: 'center'
                },
                series: prePareData,
                theme: themeJson.theme
            }

            setOption(option)
            setChartLoad(false)
        }
    }, [prePareData]);


    const downloadChartAsJPEG = () => {
        prePareData.length && domtoimage.toJpeg(document.getElementById('wholeCurveTimeSeriesChart'), { quality: 0.95, backgroundColor: 'white', style: { backgroundColor: 'white', backgroundImage: 'none', margin: '0px' } })
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = 'my-image-name.jpeg';
                link.href = dataUrl;
                link.click();
            });
    }

    function sortDynamicMonths(arr) {
        return arr.sort((a, b) => {
            // Extract the numeric part (assuming "Mo" is always at the end)
            const numA = parseFloat(a.split(" ")[0]); // Split by space and take first part
            const numB = parseFloat(b.split(" ")[0]);

            // Sort numerically
            return numA - numB;
        });
    }


    const onChangeDateWiseChart = (event) => {
        setSelectDateType(event)
    }

    const DateWiseChartOptions = [
        { label: 'Month', value: 'month' },
        { label: 'Year', value: 'year' }
    ];

    // const handleApplyChartDateType = () => {
    //     setApplyDateType(!applyDateType)
    // }


    return (
        <>
            {Object.keys(chartData)?.length > 0 ? <Card className="bg-white p-3 md:p-5 ">
                <div className='flex justify-end'>
                    {/* <div className="flex justify-center items-center gap-2 px-2">
                        <Select

                            onValueChange={(e) => onChangeDateWiseChart(JSON.parse(e))}
                        >
                            <SelectTrigger className="w-full h-[34px] min-w-[130px] text-[12px] rounded-5px] ">
                                <SelectValue
                                    className='text-textV1 '
                                    placeholder={selectDateType !== null ? selectDateType?.label : "Select Date Type"}
                                >
                                    {selectDateType !== null ? selectDateType?.label : "Select Date Type"}
                                </SelectValue>
                            </SelectTrigger>
                            <SelectContent>
                                <SelectGroup>
                                    {
                                        DateWiseChartOptions && DateWiseChartOptions.length > 0 ? DateWiseChartOptions.map((item, index) => {
                                            return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                                        }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                                    }
                                </SelectGroup>
                            </SelectContent>
                        </Select>
                        <Button className="px-5 py-[7px]" onClick={handleApplyChartDateType}>Apply</Button>
                    </div> */}
                    <Button variant="outline" size="sm" className="w-8 h-8 p-0 hover:bg-[#F5F5F5]" onClick={() => downloadChartAsJPEG('echarts-chart2')}>
                        <span><DownloadIcon className='w-4 h-4' /></span>
                    </Button>
                </div>
                <div className="table-wrapper" id='wholeCurveTimeSeriesChart'>
                    {<EChartsReact
                        key="timeSeriesChart" // Add key prop here
                        className={"lineChart_curves"}
                        notMerge={true}
                        lazyUpdate={chartLoad || isLoading}
                        showLoading={chartLoad || isLoading}
                        // theme={'dark'}
                        style={{ width: '100%', height: '500px' }}
                        option={option}
                        opts={{ renderer: 'svg' }}
                    />}
                </div>
            </Card> : ''}
        </>
    );
}

export default WholeCurveTimeSeriesChart;